import { render, staticRenderFns } from "./DeliveryRecord.vue?vue&type=template&id=3eaed286&scoped=true&"
import script from "./DeliveryRecord.vue?vue&type=script&lang=js&"
export * from "./DeliveryRecord.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryRecord.vue?vue&type=style&index=0&id=3eaed286&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eaed286",
  null
  
)

export default component.exports